
const FilterSection = ({
  title,
  category,
  options,
  selectedOptions,
  onFilterChange,
  isExpanded,
  onToggle,
  subtitle, // Add optional subtitle
}) => {
  return (
    <div className="mb-6 border-t border-gray-200 pt-4">
      <button
        className="flex justify-between items-center w-full text-left font-medium text-gray-700 mb-2"
        onClick={onToggle}
        aria-expanded={isExpanded} // Add aria-expanded for accessibility
      >
        <span>{title}</span>
        <span>{isExpanded ? "−" : "+"}</span>
      </button>

      {subtitle && (
        <p className="text-xs text-gray-500 mb-2 ml-2">{subtitle}</p>
      )}

      {isExpanded && (
        <div className="ml-2 space-y-2">
          {options.map((option) => (
            <label key={option.value} className="flex items-center">
              <input
                type="checkbox"
                className="mr-2"
                checked={selectedOptions.includes(
                  `${category}:${option.value}`
                )}
                onChange={() => onFilterChange(category, option.value)}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterSection;
